import { LocalHostSessionCredential } from "@afar-research/contracts";

/**
 * The Local Host Session is the Environment's host-process credential: the secret the launcher
 * hands the service at start and keeps in the Host Store's runtime directory, so a process on the
 * same machine (the `afar-research` CLI, the Desktop main process, the App Control Tool Surface)
 * can act as the owner. It never reaches a renderer or a browser; those pair for Environment
 * Access instead.
 */
export const LOCAL_HOST_SESSION_HEADER = "x-afar-local-host-session";
export const LOCAL_HOST_SESSION_WEBSOCKET_PROTOCOL_PREFIX = "afar-local-host-session.";

export function encodeLocalHostSessionCredential(bytes: Uint8Array): LocalHostSessionCredential {
  return LocalHostSessionCredential.make(
    Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(""),
  );
}

export function makeLocalHostSessionWebSocketProtocol(
  credential: LocalHostSessionCredential | undefined,
): string | undefined {
  if (!credential) {
    return undefined;
  }
  return `${LOCAL_HOST_SESSION_WEBSOCKET_PROTOCOL_PREFIX}${credential}`;
}
